<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    top="5vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span
        class="title-text">{{ factoryName + $t('factoryLabelPrint.templateContentEditing') }}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <input style="display: none;" ref="refImportFile" type="file" @change="importXlsx" accept=".xlsx, .xlc, .xlm, .xls, .xlt, .xlw">
    </input>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.moduleNo') + ':'" prop="moduleNo">
            <el-input
              v-model.trim="form.moduleNo"
              name="moduleNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.moduleNoQrCode') + ':'" prop="moduleNoQrCode">
            <el-input
              v-model.trim="form.moduleNoQrCode"
              name="moduleNoQrCode"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.moduleNo') + '1' + ':'" prop="moduleNo1">
            <el-input
              v-model.trim="form.moduleNo1"
              name="moduleNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.moduleNoQrCode') + '1' + ':'" prop="moduleNoQrCode1">
            <el-input
              v-model.trim="form.moduleNoQrCode1"
              name="moduleNoQrCode"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            :id="labelName"
            scrolling="no"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
          <el-button style="position: absolute; margin-left: 10px;" size="small" @click="importModuleNo">{{$t('common.import')}}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{ $t('common.print') }}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import {
  initModuleNoLabelFrame,
  printFactoryLabel,
} from '@/utils/factory-label';
import { readXlsx } from '@/utils/fileRead';

export default {
  name: "ModuleNoLabelDialog",
  props: {
    factoryName: {
      type: String,
      default: '',
    },
    labelName: {
      type: String,
      default: 'labelIFrameModeuleNoLabelDialog',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        moduleNo: undefined,
        moduleNoQrCode: undefined,
        moduleNo1: undefined,
        moduleNoQrCode1: undefined,
      },
      rules: {
        moduleNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.moduleNoCanNotBeEmpty')
        }],
        moduleNoQrCode: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.moduleNoQrCodeCanNotBeEmpty')
        }],
      },
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.initModuleNoLabelFrame();
        });
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
      if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
        this.$refs.refForm.clearValidate();
      }
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.printModuleNoLabelFrame();
        }
      });
    },
    initModuleNoLabelFrame() {
      let iframe = document.getElementById(this.labelName);
      iframe = initModuleNoLabelFrame({
        iframe,
        moduleNo: 'MC1075_2006',
        moduleNoQrCode: 'LC1000MC10752003',
        moduleNo1: 'MC1075_2007',
        moduleNoQrCode1: 'LC1000MC10752004',
      });
      iframe.contentWindow.document.close();
    },
    printModuleNoLabelFrame() {
      const {
        moduleNo,
        moduleNoQrCode,
        moduleNo1,
        moduleNoQrCode1,
      } = this.form;
      let iframe = document.getElementById(this.labelName);
      iframe = initModuleNoLabelFrame({
        iframe,
        moduleNo,
        moduleNoQrCode,
        moduleNo1,
        moduleNoQrCode1,
      });
      iframe.contentWindow.document.close();
      printFactoryLabel(iframe);
    },
    importModuleNo() {
      if (this.$refs.refImportFile && typeof this.$refs.refImportFile.dispatchEvent === 'function') {
        this.$refs.refImportFile.dispatchEvent(new MouseEvent('click'));
      }
    },
    importXlsx(e) {
      const file = e.currentTarget.files[0];
      this.$refs.refImportFile.value = null;
      const nameSuffix = file.name.split('.').reverse()[0];
      if (!(['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw'].includes(nameSuffix))) {
        this.$message({
          message: this.$t('incomeStorage.importedFileFormatIncorrect'),
          type: 'error',
        });
        return;
      }
      const isCSV = nameSuffix === 'csv';
      if (isCSV) {
        // csv2arr(file, (res) => {
        //   this.csvDataDisplay(res);
        // })
      } else {
        readXlsx(file, (res) => {
          let iframe = document.getElementById(this.labelName);
          let moduleNo;
          let moduleNoQrCode;
          let moduleNo1;
          let moduleNoQrCode1;
          let length = res.length;
          for (let index = 0; index < Math.ceil(length / 2); index++) {
            moduleNo = res[index * 2]['模块编号'];
            moduleNoQrCode = res[index * 2]['模块编号—扫描'];
            moduleNo1 = (res[index * 2 + 1] && res[index * 2 + 1]['模块编号']) || res[index * 2]['模块编号']; // 最后单数张，打印同一张
            moduleNoQrCode1 = (res[index * 2 + 1] && res[index * 2 + 1]['模块编号—扫描']) || res[index * 2]['模块编号—扫描'];  // 最后单数张，打印同一张
            iframe = initModuleNoLabelFrame({
              iframe,
              moduleNo,
              moduleNoQrCode,
              moduleNo1,
              moduleNoQrCode1,
              index,
            });
          }
          iframe.contentWindow.document.close();
          printFactoryLabel(iframe);
        });
      }
    },
  }
}
</script>

<style scoped>
.title-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-between;
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
  padding: 10px 15px;
  align-items: center;
}

.title-text {
  color: #404040;
  font-size: 16px;
}

.el-form {
  margin: 0 30px;
}

.close-image {
  width: 22px;
  height: 22px;
  cursor: pointer;
  padding: 0 10px;
}
</style>
<style>
.edit-detail-dialog .el-dialog__header {
  padding: 0;
}
</style>

